import { PawIcon } from "@/lib/brand";

export default function Marquee({ items }) {
    const Row = () => (
        <div className="flex items-center gap-14 pr-14">
            {items.map((item, i) => (
                <span key={i} className="flex items-center gap-14 whitespace-nowrap">
                    <span
                        className={`font-display uppercase font-bold text-3xl md:text-5xl tracking-wide ${
                            i % 2 === 0 ? "text-white/15" : "text-stroke-purp"
                        }`}
                    >
                        {item}
                    </span>
                    <PawIcon className="w-5 h-5 md:w-7 md:h-7 text-purp/40 shrink-0" />
                </span>
            ))}
        </div>
    );
    return (
        <div className="overflow-hidden border-y border-white/10 py-6 md:py-8 select-none bg-obsidian" data-testid="editorial-marquee">
            <div className="flex w-max animate-marquee">
                <Row />
                <Row />
            </div>
        </div>
    );
}
